
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const ServiciosHero = () => {
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9f0dec16568242140a7e673b0fc89c0c.jpg"
          alt="Servicios de Desguace en Gavá - Compra coches siniestrados"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div ref={heroRef} className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center w-full pt-20">
        <h1
          className={`text-5xl md:text-6xl font-bold text-white mb-6 leading-tight transition-all duration-700 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'
          }`}
        >
          Servicios de Desguace<br />
          <span className="text-emerald-400">en Gavá</span>
        </h1>
        
        <p
          className={`text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed transition-all duration-700 delay-200 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Soluciones completas para la <strong>compra y retirada de vehículos siniestrados, averiados o para chatarra</strong> en Gavá y toda la comarca del Baix Llobregat
        </p>
      </div>
    </section>
  );
};

export default ServiciosHero;
